import FormBuilderHost from "../../../../../pages/app/admin/library/form-builder/FormBuilderHost";
import ElevatedPaper, { DEFAULT_STYLE } from "../../../../ElevatedPaper";

const ProviderFormBuilderHost = () => {
  return (
    <ElevatedPaper sx={{ ...DEFAULT_STYLE, minHeight: "calc(100vh - 4.5rem)" }}>
      <FormBuilderHost />
    </ElevatedPaper>
  );
};

export default ProviderFormBuilderHost;
